import { useSelector } from 'react-redux';

const useLabels = () => {
  const { labels } = useSelector((state) => state.labelsSlice);

  return {
    labels,
  };
};

export default useLabels;
